<template>
    <v-data-table
          :headers="headers"
          :items="events"
          :pagination.sync="pagination"
          select-all
          item-key="id"
        >
          <template slot="headers" slot-scope="props">
            <tr>
              <th
                v-for="header in props.headers"
                class="text-xs-left subheading"
                :key="header.text"
              >{{ header.text }}</th>
              <th></th>
            </tr>
          </template>
          <template slot="items" slot-scope="props">
            <tr>
              <td class="text-xs-left body-2">
                {{ props.item.endDate != null ? moment(props.item.sessionDate).format('dddd, MMMM DD, YYYY') + ' - ' + moment(props.item.endDate).format('dddd, MMMM DD, YYYY')
                : moment(props.item.sessionDate).format('dddd, MMMM DD, YYYY')}}
              </td>
              <td
                class="text-xs-left body-2"
              >{{ moment(props.item.startTime).format('h:mm:ss a') }} - {{ moment(props.item.endTime).format('h:mm:ss a') }}</td>
              <td class="text-xs-left body-2">{{ props.item.locationName }}</td>
              <td class="text-xs-left body-2">{{ props.item.type }}</td>
              <td
                class="text-xs-left body-2"
              >{{ props.item.status != 'ACTIVE' ? props.item.status : props.item.description }}</td>
            </tr>
          </template>
    </v-data-table>
</template>

<script>
import moment from "moment";

export default {
  
   props: ['events'],
   data: () => ({
     headers: [
      { text: "Date", align: "left", value: "date" },
      { text: "Time", value: "time" },
      { text: "Location", value: "location" },
      { text: "Event", value: "Event" },
      { text: "Description", value: "description" }
    ],
     pagination: {
      sortBy: "startTime",
      rowsPerPage: 10
    },
   }),

   methods: {
      moment,
   }
}
</script>